module.exports = __webpack_public_path__ + "static/eho-img-6c55337f625c51dfa1c3e069fe3f0612.png";